import { render, staticRenderFns } from "./RestaurantEdit.vue?vue&type=template&id=3aeda8e3&"
import script from "./RestaurantEdit.vue?vue&type=script&lang=js&"
export * from "./RestaurantEdit.vue?vue&type=script&lang=js&"
import style0 from "./RestaurantEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports